import { render, staticRenderFns } from "./TableFieldNumberInput.vue?vue&type=template&id=0ffb1a46"
import script from "./TableFieldNumberInput.vue?vue&type=script&lang=js"
export * from "./TableFieldNumberInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports